// extracted by mini-css-extract-plugin
module.exports = {"section_uni_list":"uni_list_section_uni_list__y8JD_","wrapper":"uni_list_wrapper__sUmOy","list_wrapper":"uni_list_list_wrapper__dSKKj"};